<template>
  <div>
    <div id="tooltip"></div>
    <div id="chart-placeholder-verbal"></div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { intersection } from 'lodash';
  import { chordRdr, chordKey, groupTip, createMatrixAndMapVerbal } from './chordHelperFunctions';
  import filter from 'lodash/filter';
  import axios from 'axios';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
    data() {
      return {
        checked_names: [],
        chartData: []
      };
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
      ]),
    },
    methods: {
      updateFilteredIds: function () {
        return this.chartData.filter((student, index) => this.checked_names[index]).map((student) => student.participation_id);
      },
      showEmptyMessage: function () {
        this.$emit('showEmptyMessage');
      },
    },
    async mounted() {
      const { data } = await axios.get(`/api/live_discussions/${this.$route.params.liveDiscussionID}/chord-diagram-verbal`);
      this.chartData = data;
      const d3 = window.d3version3;
      this.chartData.forEach((element, index) => {
        this.checked_names[index] = true;
      });
      const that = this;
      const screenSize = window.innerWidth;
      let width = 500;
      let height = 500;
      const outerRadius = Math.min((width, height) / 2 - 40);
      const innerRadius = outerRadius - 13;
      const arc = d3.svg.arc().innerRadius(innerRadius).outerRadius(outerRadius);
      const path = d3.svg.chord().radius(innerRadius);

      function getDefaultLayout() {
        return d3.layout.chord().padding(0.05).sortSubgroups(d3.descending).sortChords(d3.ascending);
      }

      function updateChords(data) {
        const g = d3.select('#chart-placeholder-verbal').append('svg').attr('width', width).attr('height', height).append('g').attr('id', 'circle').attr('transform', `translate( ${width / 2} , ${height / 2} )`);
        g.append('circle').attr('r', outerRadius);
        const matrixAndMap = createMatrixAndMapVerbal(data);
        const matrix = matrixAndMap.matrix;
        const mmap = matrixAndMap.map;
        const rdr = chordRdr(matrix, mmap);
        const layout = getDefaultLayout();
        layout.matrix(matrix);

        function chordPath() {
          let color = '#C6C6C6';
          return color;
        }

        function chordTip(d) {
          const student1 = filter(mmap, { name: d.sname });
          const student2 = filter(mmap, { name: d.tname });
          let user_1 = null;
          let user_2 = null;
          const user_1_tapins = [];
          const user_2_tapins = [];
          data.map((d) => {
            if (d.participation_id === student1[0].name) {
              user_1 = d;
              d.turns_I_response.map((t) => {
                if(t.participation_id === student2[0].name) {
                  user_1_tapins.push(t);
                }
              });
            }
          });
          data.map((d) => {
            if (d.participation_id === student2[0].name) {
              user_2 = d;
              d.turns_I_response.map((t) => {
                if(t.participation_id === student1[0].name) {
                  user_2_tapins.push(t);
                }
              });
            }
          });
          
          student1 ? (d.sname = student1[0].data) : null;
          student2 ? (d.tname = student2[0].data) : null;

          const student1_turns_by_type = {
            new_idea: 0,
            build_on: 0,
            challenge: 0,
            question: 0,
            hand_raise: 0,
          };

          const student2_turns_by_type = {
            new_idea: 0,
            build_on: 0,
            challenge: 0,
            question: 0,
            hand_raise: 0,
          };

          user_1_tapins.map((item) => {
            if (item.turn_type === 'new_idea') {
              student1_turns_by_type.new_idea = student1_turns_by_type.new_idea + 1;
            }
            if (item.turn_type === 'challenge') {
              student1_turns_by_type.challenge = student1_turns_by_type.challenge + 1;
            }
            if (item.turn_type === 'hand_raise') {
              student1_turns_by_type.hand_raise = student1_turns_by_type.hand_raise + 1;
            } 
            if (item.turn_type === 'build_on') {
              student1_turns_by_type.build_on = student1_turns_by_type.build_on + 1;
            }
            if (item.turn_type === 'question') {
              student1_turns_by_type.question = student1_turns_by_type.question + 1;
            }
          });
          user_2_tapins.map((item) => {
            if (item.turn_type === 'new_idea') {
              student2_turns_by_type.new_idea = student2_turns_by_type.new_idea + 1;
            }
            if (item.turn_type === 'challenge') {
              student2_turns_by_type.challenge = student2_turns_by_type.challenge + 1;
            }
            if (item.turn_type === 'hand_raise') {
              student2_turns_by_type.hand_raise = student2_turns_by_type.hand_raise + 1;
            }
            if (item.turn_type === 'build_on') {
              student2_turns_by_type.build_on = student2_turns_by_type.build_on + 1;
            }
            if (item.turn_type === 'question') {
              student2_turns_by_type.question = student2_turns_by_type.question + 1;
            }
          });

          const name1 = d.sname.split(' ').slice(0, -1).join(' ');
          const name2 = d.tname.split(' ').slice(0, -1).join(' ');

          let turns_1 = '';
          let turns_2 = '';

          for (let key in student1_turns_by_type) {
            if (student1_turns_by_type[key] > 0) {
              let color = '';
              let icon = '';
              let turnType = '';
              if (key === 'new_idea') {
                color = 'primary';
                turnType = 'New Idea';
                icon = '<i class="fa-solid fa-play"></i>';
              }
              if (key === 'challenge') {
                color = 'pinky';
                turnType = 'Challenge';
                icon = '<i class="fa-solid fa-circle"></i>';
              }
              if (key === 'build_on') {
                color = 'green';
                turnType = 'Build On';
                icon = '<i class="fa-solid fa-square"></i>';
              }
              if (key === 'question') {
                color = 'darkBlue-dark';
                turnType = 'Question';
                icon = '<i class="fa-solid fa-circle-question"></i>';
              }
              if (key === 'hand_raise') {
                color = 'orange';
                turnType = 'Add by Teacher';
                icon = '<i class="fa-solid fa-chalkboard-user"></i>';
              }
              turns_1 = turns_1 + `<li class="flex items-center space-x-2 mb-1">
                  <div class="flex text-white bg-${color} rounded py-1 px-2.5 items-center space-x-2">
                    ${icon}
                    <span class="font-poppins text-xs">${turnType} (${student1_turns_by_type[key]})</span>
                  </div>
                </li>`;
            }
          }

          for (let key in student2_turns_by_type) {
            if (student2_turns_by_type[key] > 0) {
              let color = '';
              let turnType = '';
              let icon = '';
              if (key === 'new_idea') {
                color = 'primary';
                turnType = 'New Idea';
                icon = '<i class="fa-solid fa-play"></i>';
              }
              if (key === 'challenge') {
                color = 'pinky';
                turnType = 'Challenge';
                icon = '<i class="fa-solid fa-circle"></i>';
              }
              if (key === 'build_on') {
                color = 'green';
                turnType = 'Build On';
                icon = '<i class="fa-solid fa-square"></i>';
              }
              if (key === 'question') {
                color = 'darkBlue-dark';
                turnType = 'Question';
                icon = '<i class="fa-solid fa-circle-question"></i>';
              }
              if (key === 'hand_raise') {
                color = 'orange';
                turnType = 'Add by Teacher';
                icon = '<i class="fa-solid fa-chalkboard-user"></i>';
              }
              turns_2 = turns_2 + `
                <li class="flex items-center space-x-2 mb-1">
                  <div class="flex text-white bg-${color} rounded py-1 px-2.5 items-center space-x-2">
                    ${icon}
                    <span class="font-poppins text-xs">${turnType} (${student2_turns_by_type[key]})</span>
                  </div>
                </li>`
              ;
            }
          }

          return `
            <div class="px-1.5 py-1">
              <div class="mb-2">
                <div class="flex items-center space-x-2 mb-2">
                  <img class="w-6 h-6 rounded-full" src='${user_1.avatar_url}'/>
                  <span>${name1 === '' ? d.sname : name1} responses after ${name2 === '' ? d.tname : name2} (${user_1_tapins.length})</span>
                </div>
                <ul>
                  ${turns_1}
                </ul>
              </div>
              <div>
                <div class="flex items-center space-x-2 mb-2">
                  <img class="w-6 h-6 rounded-full" src='${user_2.avatar_url}'/>
                  <span>${name2 === '' ? d.tname : name2} responses after ${name1 === '' ? d.sname : name1} (${user_2_tapins.length})</span>
                </div>
                <ul>
                  ${turns_2}
                </ul>
              </div>
            </div>`;
        }
        function arcTween() {
          return (d) => {
            const emptyArc = { startAngle: d.startAngle, endAngle: d.startAngle };
            const tween = d3.interpolate(emptyArc, d);
            return (t) => arc(tween(t));
          };
        }
        function chordTween() {
          return (d) => {
            const emptyChord = {
              source: { startAngle: d.source.startAngle, endAngle: d.source.startAngle },
              target: { startAngle: d.target.startAngle, endAngle: d.target.startAngle },
            };
            const tween = d3.interpolate(emptyChord, d);
            return (t) => path(tween(t));
          };
        }
        const groupG = g.selectAll('g.group').data(layout.groups(), (d) => d.index);
        groupG.exit().remove() .transition().duration(500).attr('opacity', 0);
        const newGroups = groupG.enter().append('g').attr('class', 'group');
        newGroups.append('path').attr('id', (d) => `group ${d.index}`).style('fill', () => `#C6C6C6`).style('stroke', 'black');
        groupG.select('path').transition().duration(300).attr('opacity', 0.5).attrTween('d', arcTween()).transition().duration(100).attr('opacity', 1);

        newGroups.append('svg:text').transition().duration(100).each((d) => {
          d.angle = (d.startAngle + d.endAngle) / 2;
        }).attr('dy', '.35em').attr('text-anchor', (d) => {
          d.angle > Math.PI ? 'end' : null;
        }).attr('transform', (d) => {
          `rotate(${(d.angle * 180) / Math.PI - 90})
          translate(${innerRadius + 26})
          ${d.angle > Math.PI ? 'rotate(180)' : 'rotate(0)'}`;
        }).text((d) => rdr(d).gdata);

        groupG.select('text').transition().duration(300).attr('transform', (d) => {
          d.angle = (d.startAngle + d.endAngle) / 2;
          return `rotate(${(d.angle * 180) / Math.PI - 90}) translate(${innerRadius + 26}) ${d.angle > Math.PI ? 'rotate(180)' : 'rotate(0)'}`;
        }).attr('text-anchor', (d) => (d.angle > Math.PI ? 'end' : 'begin'));

        const chordPaths = g.selectAll('path.chord').data(layout.chords(), chordKey);
        chordPaths.enter().append('path').attr('class', 'chord');
        chordPaths.exit().transition().duration(800).attr('opacity', 0).remove();

        chordPaths.transition().duration(500).attr('opacity', 1).style('fill', (d) =>  chordPath(rdr(d))).style('stroke', () => {
          d3.rgb(`#72CCCD`).darker();
        }).attrTween('d', chordTween()).transition().duration(100).attr('opacity', 1);

        let positionLeft = 17;
        const is_modal = document.getElementsByClassName('modal-body');

        if (screenSize < 400) {
          positionLeft = 0;
        } else if (is_modal.length !== 0) {
          positionLeft = 20;
        }

        /* paths.each(function() { pathData.push(this); }); */

        

        chordPaths.on('mouseover', function showTooltip(d) {
          d3.select('#tooltip').style('visibility', 'visible').html(chordTip(rdr(d))).style('flex', 'justify-center').style('right', () => positionLeft + '%');
          d3.selectAll('.chord').classed('opacity', true);
          d3.select(this).classed('opacity', false);
        });
        chordPaths.on('mouseout', () => {
          d3.select('#tooltip').style('visibility', 'hidden');
        });
        groupG.on('mouseover', (d) => {
          d3.select('#tooltip').style('visibility', 'visible').html(groupTip(rdr(d))).style('flex', 'justify-center').style('right', () => positionLeft + '%');
          chordPaths.classed('fade', (p) => p.source.index !== d.index && p.target.index !== d.index);
        });
        groupG.on('mouseout', () => d3.select('#tooltip').style('visibility', 'hidden'));
        that.last_layout = layout;
      }

      const createChart = () => {
        const svg = document.querySelector('#chart-placeholder-verbal svg');
        if (svg) {
          svg.parentNode.removeChild(svg);
        }
        const filteredIds = this.updateFilteredIds();
        const filteredStudents = this.chartData.filter((student) => filteredIds.includes(student.participation_id));
        let commentedTo = [];
        filteredStudents.forEach((e) => {
          commentedTo = [...commentedTo, ...e.turns_I_response.map((t) => t.participation_id)];
        });
        if (intersection(commentedTo, filteredIds).length > 0) {
          updateChords(filteredStudents);
        } else {
          this.showEmptyMessage();
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange, false);

      function handleVisibilityChange() {
        if (document.visibilityState === 'hidden') {
          return null;
        } else {
          d3.select('#chart-placeholder-verbal').selectAll('svg').remove();
          createChart();
        }
      }

      createChart();
      d3.select('#filter-button').on('click', () => {
        d3.select('#chart-placeholder-verbal').selectAll('svg').remove();
        createChart();
      });
    },
    beforeDestroy: async function() {
      const svg = document.querySelector('#chart-placeholder-verbal svg');
      if (svg) {
        svg.parentNode.removeChild(svg);
      }
    }
  });
</script>
<style scoped lang="scss">
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  #chart-placeholder-verbal {
    height: 100%;
  }
  .filter-box {
    animation: fadein 1s;
    text-align: left;
    padding-top: 20px;
    padding-left: 35px;
  }
  .checkboxes-container {
    height: 30px;
  }
  #tooltip {
    color: rgb(29, 29, 29);
    font-size: 13px;
    opacity: 0.9;
    background: white;
    padding: 5px;
    border: 1px solid lightgrey;
    border-radius: 5px;
    position: absolute;
    z-index: 10;
    visibility: hidden;
    white-space: nowrap;
    pointer-events: none;
  }
  form .btn-primary {
    margin-top: 25px;
  }
  #circle circle {
    fill: none;
    pointer-events: all;
  }
  path.chord {
    fill-opacity: 0.9;
    transition: opacity 0.3s;
  }
  #circle:hover path.fade {
    opacity: 0;
  }
  svg {
    font-size: 11px;
    color: #999;
  }
  #circle:hover path.fade {
    display: none;
  }
  #circle:hover path.opacity {
    opacity: 0.3;
    transition: opacity 200ms;
  }
</style>



// WEBPACK FOOTER //
// ChordDiagramverbal.vue?2d822141